// Discovery search radius in metres used until the user picks another one.
export const DEFAULT_RADIUS = 20000
